import React from 'react'

export class AnimatedMobile extends React.Component {
    constructor(props) {
        super(props);
        this.state = { number: "" };

        this.len = this.props.number.length;

        for (var i = 0; i < this.len; i++) {
            this.state.number = this.state.number + "_";
        }
        this.cursor = 0;
        this.handleClick = this.handleClick.bind(this);
    }

    handleClick() {


        if (this.cursor >= this.len)
            return;

        //    this.state.number=this.props.number[this.cursor]+this.state.number;
        this.state.number = "";
        var blank = "";
        for (var i = 0; i < this.len; i++) {
            if (i <= this.cursor)
                this.state.number = this.state.number + this.props.number[i];
            else
                blank = blank + "_";
        }
        this.state.number=blank+this.state.number;

        this.cursor++;
        this.setState({});

        setTimeout(
            function () {
                this.handleClick();
            }
                .bind(this),
            300
        );



    }


    componentDidMount() {
        setTimeout(
            function () {
                this.handleClick();
            }
                .bind(this),
            2000
        );
    }

    render() {

        return (
            <span >{traverse(this.state.number)}</span>
        )
    }
}

const persian = { 0: '۰', 1: '۱', 2: '۲', 3: '۳', 4: '۴', 5: '۵', 6: '۶', 7: '۷', 8: '۸', 9: '۹' };
function traverse(el) {
    el = el.toString();
    var list = el.match(/[0-9]/g);
    if (list != null && list.length !== 0) {
        for (var i = 0; i < list.length; i++)
            el = el.replace(list[i], persian[list[i]]);
    }
    return el;


}


// WEBPACK FOOTER //
// ./src/elements/AnimatedMobile.js